module.exports = __webpack_public_path__ + "img/settings-icon-white.376b2db6.svg";